encodedPrefix